export default __webpack_public_path__ + "static/media/landin-blockimg16.79278421.png";